(function () {
  jQuery('.js-accordion').slideAccordion({
    opener: '.tab-item__opener',
    slider: '.tab-item__content',
    animSpeed: 300
  });
  jQuery('.js-session-accordion').slideAccordion({
    opener: '.js-session-accordion-btn',
    slider: '.js-session-accordion-content',
    animSpeed: 300
  });
})();